import { filter, mapTo, switchMap, takeUntil, tap } from "rxjs/operators";
import { eventsCanvas } from "../../../../events/eventsCanvas";
import { selectIsTutorialActive } from "../../../../selectors/selectTutorial";
import { IdEventSoundCore } from "../../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../../utils/sound/utilSound";
import { TypeActionOutskirtsInfo } from "../../../info/outskirts/actionOutskirtsInfo";
import { actionBuildingsDeselect, TypeActionBuildings } from "../actionBuildings";
export var epicBuildingsDeselect = function (action$, state$) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.Select ||
            action.type === TypeActionOutskirtsInfo.SelectOutskirtBuilding;
    }), switchMap(function () {
        return eventsCanvas.click$.pipe(takeUntil(action$.pipe(filter(function (_a) {
            var type = _a.type;
            return type === TypeActionBuildings.StartMove ||
                type === TypeActionBuildings.Rotate ||
                type === TypeActionBuildings.StartUnstoreBuilding ||
                type === TypeActionBuildings.Deselect ||
                type === TypeActionBuildings.Select;
        }))), filter(function () { return !selectIsTutorialActive(state$.value); }), tap(function () { return utilSound.event(IdEventSoundCore.ButtonClick); }), mapTo(actionBuildingsDeselect()));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsDeselect.ts
// module id = 2053
// module chunks = 3